// extracted by mini-css-extract-plugin
export default {"container":"About_container__R0pB3","card":"About_card__9rz4n"};